<div
  [attr.data-tid]="muted() ? 'volume/muted' : 'volume/unmuted'"
  aria-hidden="true"
  class="volume-indicator"
>
  @if (!muted()) {
  <av-icon name="mic" mode="light" class="volume-indicator-icon"></av-icon>
  <div class="volume-indicator-container">
    <div class="volume-indicator-strength" #volumeRef></div>
  </div>
  } @if (muted()) {
  <av-icon class="volume-indicator-icon" name="mic-mute" mode="light"></av-icon>
  }
</div>
